import React, { useState } from 'react';
import {
    UPDATE_CURRENT_DOSSIER_CTX,
    useCurrentDossierCtx,
    useCurrentDossierCtxDispatch,
} from '@europrocurement/l2d-modules/modules/Dossiers/providers';
import { useFormaliteService } from '@europrocurement/l2d-domain';
import { useSnackbar } from 'notistack';
import InfoCardDossier from '../../InfoCardDossier/InfoCardDossier';
import EditablePriorityChip from '../../EditablePriorityChip/EditablePriorityChip';
import { PriorityCardProps } from './types';

const PriorityCard: React.FunctionComponent<PriorityCardProps> = function ({
    critical,
    infoCardSx,
}) {
    const { dossier } = useCurrentDossierCtx();
    const { collectionApi } = useFormaliteService();
    const dispatchCurrentDossier = useCurrentDossierCtxDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    /**
     * Gère la modification de la priorité du dossier
     */
    const handlePriorityChange = async (newCritical: boolean) => {
        try {
            setIsLoading(true);

            if (!dossier?.collectionId) {
                throw new Error('ID commande du dossier manquant');
            }

            const updatedDossier = await collectionApi.apiCollectionsDossiersIdPatch({
                id: dossier.collectionId.toString(),
                collectionDeDossierCollectiondossierUpdate: {
                    urgent: newCritical,
                },
            });

            if (updatedDossier && dispatchCurrentDossier) {
                dispatchCurrentDossier({
                    type: UPDATE_CURRENT_DOSSIER_CTX,
                    payload: {
                        dossierId: dossier.id as number,
                        data: {
                            ...dossier,
                            critical: newCritical,
                        },
                    },
                });
            }

            enqueueSnackbar(`Priorité modifiée en ${newCritical ? 'urgent' : 'normal'}`, {
                variant: 'success',
            });
        } catch (error) {
            console.error('Erreur lors de la mise à jour de la priorité:', error);
            enqueueSnackbar('Impossible de modifier la priorité du dossier', {
                variant: 'error',
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <InfoCardDossier
            label="Priorité "
            sx={infoCardSx}
        >
            <EditablePriorityChip
                critical={critical}
                onPriorityChange={handlePriorityChange}
                isLoading={isLoading}
                fontSx={{ fontSize: '13px' }}
            />
        </InfoCardDossier>
    );
};

export default PriorityCard;
